export default "__VITE_ASSET__DN$H7kOv__"